// extracted by mini-css-extract-plugin
export default {"activity_button":"hn","title_wrapper":"in","title":"jn","subtitle":"kn","label":"ln","active":"mn"};
    if(module.hot) {
      // 1713211511799
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  